import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { ReportsServiceProvider } from '../../api/reports'

const ReportsService = ReportsServiceProvider()
const name = 'getReportsPowerBiToken'

export default (email) => (asyncAction(
  name,
  ReportsService.getReportsPowerBiToken,
  { email }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/reports/getReportsPowerBiToken.js